"use client";

import { c as _c } from "react/compiler-runtime";
import Avatar from "sigma-avatars";
import OptimizedImage from "@/components/optimized-image";
import { Skeleton } from "@/components/ui/skeleton";
import { getDisplayImageUrl } from "@/lib/image-utils";

/** OAuth client header with avatar/name */
export function OAuthClientHeader(t0) {
  const $ = _c(16);
  const {
    clientProfile,
    loadingClientInfo,
    oauthClient
  } = t0;
  if (!oauthClient) {
    return null;
  }
  if (loadingClientInfo) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton className="h-16 w-16 rounded-full" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex flex-col items-center gap-2">{t1}<div className="space-y-2 text-center"><Skeleton className="mx-auto h-6 w-32" /><Skeleton className="mx-auto h-4 w-48" /></div></div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t1;
  if ($[2] !== clientProfile) {
    t1 = clientProfile?.identity?.image && getDisplayImageUrl(clientProfile.identity.image);
    $[2] = clientProfile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const imageUrl = t1;
  let t2;
  if ($[4] !== imageUrl || $[5] !== oauthClient.clientName || $[6] !== oauthClient.ownerBapId) {
    t2 = <div className="relative">{imageUrl ? <OptimizedImage alt={oauthClient.clientName} className="h-14 w-14 rounded-full ring-2 ring-border" height={56} quality={90} src={imageUrl} width={56} /> : <div className="h-14 w-14 overflow-hidden rounded-full bg-muted ring-2 ring-border"><Avatar colors={["var(--chart-1)", "var(--chart-2)", "var(--chart-3)", "var(--chart-4)", "var(--chart-5)"]} name={oauthClient.ownerBapId} size={56} variant="pixel" /></div>}</div>;
    $[4] = imageUrl;
    $[5] = oauthClient.clientName;
    $[6] = oauthClient.ownerBapId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== oauthClient.clientName) {
    t3 = <div className="font-semibold">{oauthClient.clientName}</div>;
    $[8] = oauthClient.clientName;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-muted-foreground text-sm">wants to access your Bitcoin identity</div>;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3) {
    t5 = <div>{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <div className="flex flex-col items-center gap-2 text-center">{t2}{t5}</div>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}